module.exports = __webpack_public_path__ + "img/dinamo_pb_icon_light.8c7e30a0.png";